import React, { useState, useCallback } from "react";
import { useRevalidator } from "react-router-dom";

import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

import Paper from "Components/UI/Paper";

import usePost from "Hooks/usePost";
import { Typography } from "@mui/material";

import { updateClient } from "API/swesum";
import { updateClientMySite } from "API/myPages";
import { ClientForm } from "./components/ClientForm";
import { useAuth } from "Hooks/useAuth";

import { BOOLVALUE } from "utils/options/BOOLVALUE";
import { COUNTRYCODE } from "utils/options/COUNTRYCODE";
import { LANGUAGECODE } from "utils/options/LANGUAGECODE";
import { DEFAULT_SERVICE } from "utils/options/DEFAULT_SERVICE";
import { AGREEMENT_OPTIONS } from "utils/options/AGREEMENT_OPTIONS";
import { usePopupNotificationContext } from "Context/NotificationPopup";

export function MyPagesCard({ client, endcustomers, paymentMethods }) {
  const boolOptions = BOOLVALUE;
  const countryCodes = COUNTRYCODE;
  const languageCodes = LANGUAGECODE;
  const services = DEFAULT_SERVICE;
  const agreementOptions = AGREEMENT_OPTIONS;
  const { isAdmin } = useAuth();

  const { openError, openSuccess } = usePopupNotificationContext();
  const [editMode, setEditMode] = useState(false);
  const revalidator = useRevalidator();

  const updateClientReq = usePost({
    mtnFunc: (body) => {
      if (!isAdmin) {
        return updateClientMySite(client.Id, body);
      }
      return updateClient(client.Id, body);
    },
    onError: () => {
      openError("Ett fel har uppstått", 5000);
    },
    onSuccess: (data) => {
      openSuccess(`Sparat! ${data.ParseMessage && data.ParseMessage} `, 3000);
      setEditMode(false);
      revalidator.revalidate();
    },
  });

  const [formData, setFormData] = useState({
    Address: client.Address ? client.Address : "",
    Address2: client.Address2 ? client.Address2 : "",
    BankAccountNumberIBAN: client.BankAccountNumberIBAN
      ? client.BankAccountNumberIBAN
      : "",
    BankBICCode: client.BankBICCode ? client.BankBICCode : "",
    BankGiroNumber: client.BankGiroNumber ? client.BankGiroNumber : "",
    PlusGiroNumber: client.PlusGiroNumber ? client.PlusGiroNumber : "",
    VATRegistration: client.VATRegistration ? client.VATRegistration : "",
    CreditFees: client.CreditFees ? client.CreditFees : "",
    CaseHandler: client.CaseHandler ? client.CaseHandler : "",
    City: client.City ? client.City : "",
    Id: client.Id ? client.Id : "",
    ContactPerson: client.ContactPerson ? client.ContactPerson : "",
    ContactPerson2: client.ContactPerson2 ? client.ContactPerson2 : "",
    CountryCode: client.CountryCode ? client.CountryCode : "",
    CreateTime: client.CreateTime ? client.CreateTime : "",
    DefaultAgreement: client.DefaultAgreement ? client.DefaultAgreement : "",
    DefaultService: client.DefaultService ? client.DefaultService : "",
    Email: client.Email ? client.Email : "",
    FfdLevel1: client.FfdLevel1 ? client.FfdLevel1 : "",
    Ffd1CreditFee: client.Ffd1CreditFee ? client.Ffd1CreditFee : "",
    FfdLevel2: client.FfdLevel2 ? client.FfdLevel2 : "",
    Ffd2CreditFee: client.Ffd2CreditFee ? client.Ffd2CreditFee : "",
    FfdLevel3: client.FfdLevel3 ? client.FfdLevel3 : "",
    Ffd3CreditFee: client.Ffd3CreditFee ? client.Ffd3CreditFee : "",
    LanguageCode: client.LanguageCode != null ? client.LanguageCode : "",
    LatePaymentInterestPercentage: client.LatePaymentInterestPercentage
      ? client.LatePaymentInterestPercentage
      : "",
    MobileNumber: client.MobileNumber ? client.MobileNumber : "",
    MaxCredit: client.MaxCredit ? client.MaxCredit : "",
    Name: client.Name ? client.Name : "",
    Name2: client.Name2 ? client.Name2 : "",
    OrgNo: client.OrgNo ? client.OrgNo : "",
    Pm1WaitCreate: client.Pm1WaitCreate ? client.Pm1WaitCreate : "",
    OriginalFfd: client.OriginalFfd ? client.OriginalFfd : "",
    Pm2WaitCreate: client.Pm2WaitCreate ? client.Pm2WaitCreate : "",
    Pm1Fee: client.Pm1Fee ? client.Pm1Fee : "",
    Pm1Ffd: client.Pm1Ffd ? client.Pm1Ffd : "",
    CollectionWaitCreate: client.CollectionWaitCreate
      ? client.CollectionWaitCreate
      : "",
    Pm2Fee: client.Pm2Fee ? client.Pm2Fee : "",
    Pm2Ffd: client.Pm2Ffd ? client.Pm2Ffd : "",
    PostalCode: client.PostalCode ? client.PostalCode : "",
    PurchaseCreditFeePercentage: client.PurchaseCreditFeePercentage
      ? client.PurchaseCreditFeePercentage
      : "",
    PurchaseDirectPaymentPercentage: client.PurchaseDirectPaymentPercentage
      ? client.PurchaseDirectPaymentPercentage
      : "",
    Regress: client.Regress ? client.Regress : "",
    ParseStatus: client.ParseStatus ? client.ParseStatus : "",
    ParseMessage: client.ParseMessage ? client.ParseMessage : "",
    SystemStatus: client.SystemStatus ? client.SystemStatus : "",
    ServiceFee: client.ServiceFee ? client.ServiceFee : "",
    TelephoneNumber: client.TelephoneNumber ? client.TelephoneNumber : "",
    Template: client.Template != null ? client.Template : 0,
    Website: client.Website ? client.Website : "",
    UC_OrganisationNumber: client.UC_OrganisationNumber
      ? client.UC_OrganisationNumber
      : "",
    UC_NumberOfComplaints: client.UC_NumberOfComplaints
      ? client.UC_NumberOfComplaints
      : "",
    UC_Status: client.UC_Status ? client.UC_Status : "",
    UC_Message: client.UC_Message ? client.UC_Message : "",
    UC_CreateTime: client.UC_CreateTime ? client.UC_CreateTime : "",
    AddReferencePercentage: client.AddReferencePercentage
      ? client.AddReferencePercentage
      : "",
  });

  const handleInputChange = useCallback(
    (field, newVal) => {
      setFormData({ ...formData, [field]: newVal });
    },
    [formData]
  );

  return (
    <>
      <Paper>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography sx={{ marginBottom: "1.0rem" }} variant="h5" align="left">
            Klientkort
          </Typography>
        </Box>
        <ClientForm
          formData={formData}
          FORM_MODE={editMode ? "EDIT" : "LOCKED"}
          endcustomers={endcustomers}
          handleInputChange={handleInputChange}
          countryCodes={countryCodes}
          languageCodes={languageCodes}
          services={services}
          paymentMethods={paymentMethods}
          agreementOptions={agreementOptions}
          boolOptions={boolOptions}
          client={client}
        />

        <Grid
          item
          xs={12}
          sx={{ marginTop: 2, display: "flex", justifyContent: "flex-end" }}
        >
          {editMode ? (
            <>
              <Button onClick={() => setEditMode(false)} size="small">
                Stäng
              </Button>
              {isAdmin ? (
                <> 
                  <Button
                        onClick={() => updateClientReq.post(formData)}
                        sx={{ ml: 3 }}
                        variant="contained"
                        size="small"
                      >
                        Spara
                  </Button> 
                </>
              ) : (
                <>
                   <Button
                      onClick={() => updateClientReq.post(formData)}
                      sx={{ ml: 3 }}
                      variant="contained"
                      size="small"
                    >
                      Spara
                    </Button> 
                </>
              ) 
            } 
            </>
          ) : (
            <Button
              onClick={() => setEditMode(true)}
              variant="contained"
              size="small"
            >
              Editera
            </Button>
          )}
        </Grid>
      </Paper>
    </>
  );
}
